import React from 'react';
import { MegaphoneIcon } from 'lucide-react';

import PageContainer from '@/components/layout/PageContainer';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';

import CompanyNpsReportsTable from './CompanyNpsReportsTable';

const CompanyNpsReports: React.FC = () => {
  const { checkAuthorization } = useAuthSessionStore();
  const canList = checkAuthorization(({ can }) => can('list', 'nps'));

  if (!canList) {
    return (
      <PageContainer title="Relatórios NPS">
        <Alert>
          <MegaphoneIcon data-icon="inline-start" />
          <AlertTitle>Acesso negado</AlertTitle>
          <AlertDescription>
            Você não tem permissão para listar relatórios NPS.
          </AlertDescription>
        </Alert>
      </PageContainer>
    );
  }

  return (
    <PageContainer title="Relatórios NPS">
      <CompanyNpsReportsTable />
    </PageContainer>
  );
};

export default CompanyNpsReports;
